<script>
import MediaLink from '@/components/MediaLink';
import Button from '@/components/Button';
import { checkCloseModalMenu } from '@/scripts/methods';
import { mediaLinks } from '@/scripts/constants/map';

export default {
  name: 'Footer',
  components: {
    Button,
    MediaLink,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.mediaLinks = mediaLinks;
  },
  mounted() {},
  methods: {
    checkCloseModalMenu,
  },
};
</script>

<template>
  <div :class="{ footer: true, 'is-modal': modal }">
    <div class="footer__top">
      <div class="footer__item footer__item--main">
        <div class="footer__logo">
          <img :src="require('@/assets/svg/logo-footer.svg')" />
        </div>
        <div class="footer__description">
          Killer Rewards - Get rewarded for every kill you make in you favorite
          games.
        </div>
        <div class="footer__social">
          <!-- media -->
          <div class="social">
            <!-- map -->
            <div v-for="item in mediaLinks" :key="item.id" class="social__item">
              <MediaLink :item="item"></MediaLink>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__item footer__item--menu">
        <div class="menu">
          <div class="menu__title">Help</div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com"
              @click="checkCloseModalMenu"
              target="_blank"
              >Support</a
            >
          </div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/?article=rush-rewards"
              @click="checkCloseModalMenu"
              target="_blank"
              >Rewards</a
            >
          </div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/blog"
              @click="checkCloseModalMenu"
              target="_blank"
              >Blog</a
            >
          </div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/?article=referrals"
              @click="checkCloseModalMenu"
              target="_blank"
              >Referrals</a
            >
          </div>
        </div>
      </div>
      <div class="footer__item footer__item--menu">
        <div class="menu">
          <div class="menu__title">About Player Rush</div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/?article=terms-of-service"
              @click="checkCloseModalMenu"
              target="_blank"
              >Terms</a
            >
          </div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/?article=privacy-policy"
              @click="checkCloseModalMenu"
              target="_blank"
              >Privacy Policy</a
            >
          </div>
          <div class="menu__item">
            <a
              href="//support.playerrush.com/faq"
              @click="checkCloseModalMenu"
              target="_blank"
              >FAQ</a
            >
          </div>
          <div class="menu__item">
            <a
              href="mailto:support@playerrush.com"
              @click="checkCloseModalMenu"
              target="_blank"
              >Contact</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <div class="footer__terms-link">
        <Button to="/terms" class="link-terms">Terms and conditions</Button>
      </div>
      <div class="footer__text">©2020 - Playerrush | All Rights Reserved</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.footer {
  margin-left: -30px;
  padding: 43px 0 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);

  &__top {
    display: flex;
    width: 100%;
    padding: 0 128px 0 43px;
  }

  &__item {
    &--main {
      width: 50%;
    }

    &--menu {
      width: 16%;
      margin-left: 13px;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 28px;

    img {
      display: flex;
      max-width: 100%;
    }
  }

  &__description {
    max-width: 370px;
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    color: rgba(2255, 255, 255, 0.8);
  }

  &__social {
    margin: 40px 0 50px;
    display: flex;
    justify-content: flex-start;
  }

  &__bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 128px 0 38px;
    border-top: 1px solid rgba(194, 209, 217, 0.1);
  }

  &__text {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 21px;
    color: rgba(255, 255, 255, 0.7);
  }

  &--main {
    margin: 0;
    padding-top: 35px;

    .footer__social {
      margin-top: 63px;
    }

    .footer__item--menu + .footer__item--menu {
      margin-left: 38px;
    }

    .footer__top,
    .footer__bottom {
      margin: 0 auto;
      max-width: 1210px;
      width: 100%;
      padding: 10px 20px 0;
    }
  }
}

.menu {
  &__title {
    font-family: Poppins-SemiBold;
    font-size: 14px;
    line-height: 20px;
    color: #00b8f9;
    margin-bottom: 15px;
  }

  &__item {
    display: flex;
    align-items: center;

    & + & {
      margin-top: 8px;
    }
  }

  a {
    font-family: Poppins-Regular;
    text-decoration: none;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(2255, 255, 255, 0.5);
    transition: all 0.2s;

    &:hover {
      color: rgba(2255, 255, 255, 0.8);
    }
  }
}

.social {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-top: -15px;

  &__item {
    margin-left: 15px;
    margin-top: 15px;
  }
}

@media (max-width: $mobile) {
  .footer {
    &.hide-mobile {
      display: none;
    }

    &.is-modal {
      margin: 0;
      padding: 0;
      border: 0;
      margin-top: 15px;

      .footer__logo {
        display: none;
      }

      .footer__top {
        padding: 0;
        flex-wrap: wrap;
      }

      .footer__item {
        width: 100%;
        margin: 0;

        &--main {
          padding: 25px 15px;
          border-top: 1px solid rgba(194, 209, 217, 0.1);
        }

        &--menu {
          border-top: 1px solid rgba(194, 209, 217, 0.1);
          padding: 25px 15px 0;
        }
      }

      .footer__item--menu + .footer__item--menu {
        border: 0;
        padding-top: 40px;
        margin-bottom: 25px;
      }

      .footer__social {
        margin-top: 30px;
        margin-bottom: 0;
      }

      .footer__bottom {
        padding: 20px 15px 20px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .footer__text + .footer__text {
        margin-top: 12px;
      }

      .footer__terms-link + .footer__text {
        margin-top: 12px;
      }
    }

    &--main {
      .footer__top {
        flex-wrap: wrap;
        padding: 8px 15px 0;
      }

      .footer__item {
        width: 100%;

        &--menu {
          margin-top: 40px;
          margin-left: 0 !important;
        }
      }

      .footer__social {
        margin-top: 40px;
        margin-bottom: 0;
      }

      .footer__bottom {
        margin-top: 40px;
        flex-direction: column;
        justify-content: center;
        padding: 18px 15px 20px;
      }

      .footer__text + .footer__text {
        margin-top: 10px;
      }

      .footer__terms-link + .footer__text {
        margin-top: 10px;
      }

      .media-link {
        width: 40px;
        height: 40px;
      }

      .social__item {
        margin-left: 0;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }

      .social {
        margin-left: 0;
      }
    }
  }
}
</style>
